import axios from '@axios'

const route = 'sales/payments_sales'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getPayments(context, { itemsPerPage, page, filters }) {
      return axios.post(`${route}?page=${page}&items_per_page=${itemsPerPage}`, filters)
    },

    exportExcel(context, filters) {
      return axios.post(`${route}/export_excel`, filters, {
        responseType: 'blob',
      })
    },
  },
}
